import load from 'load-script';
export class TapFiliate {
    constructor() { }
    static load(callback = () => { }) {
        load('https://script.tapfiliate.com/tapfiliate.js', () => {
            let t = window, a = 'tap', p;
            t.TapfiliateObject = a;
            t.tap =
                t.tap ||
                    function () {
                        (t.tap.q = t.tap.q || []).push(arguments);
                    };
            window.tap('create', '10378-e69988');
            window.tap('detect', {
                cookie_domain: 'invideo.io',
            });
            callback();
        });
    }
    static send({ type, data }) {
        window.tap(type, data);
    }
}
